"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMatchingEntryByDirection = void 0;
const clone_1 = require("./clone");
/**
 * passing 'asc' to direction will return the (matching) entry closest to array[0]
 */
function getMatchingEntryByDirection(array, direction, matching) {
    if (direction === 'asc') {
        return matching ? array.find(matching) : array[0];
    }
    const arrayClone = (0, clone_1.clone)(array);
    // ! Clone the array because reverse mutates the original array
    // ? Find by the end (desc) or return the first entry
    return matching ? arrayClone.reverse().find(matching) : array[array.length - 1];
}
exports.getMatchingEntryByDirection = getMatchingEntryByDirection;
//# sourceMappingURL=getMatchingEntryByDirection.js.map